module.exports = __webpack_public_path__ + "img/ic-visa-no-color.e93dce33.svg";